"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDescription = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var FormDescription = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    return react_1.default.createElement(storybook_1.Forms.Textarea, { name: 'description', value: value, placeholder: 'Omschrijving', onChange: function (value) { return onChange(value); } });
};
exports.FormDescription = FormDescription;
